import {type NodeData, type NodeDataMap} from '../../../values/nodes/NodeData'
import {type AssetVersion} from './types/software-inventory-response'
import {type TimestampFilter} from './types/software-inventory-filter'

export function getVesselForGivenAsset(
    assetVersion: AssetVersion | undefined,
    nodes: NodeDataMap,
): NodeData | null {
    const identity = assetVersion?.identity
    if (!identity || !nodes.has(identity)) {
        return null
    }
    return nodes.get(identity) ?? null
}

export function formatTimestampCriteria(searchedTimestamp: TimestampFilter): string | null {
    switch (searchedTimestamp) {
        case 'Last 24h':
            return '-24h'
        case 'Last 7 days':
            return '-168h'
        case 'Last 30 days':
            return '-720h'
        case 'All':
        default:
            return null
    }
}
